import React from "react";

function RupeeSVGnew(classes: any) {
  return (
    <svg
      width="35"
      height="35"
      viewBox="0 0 48 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M43.5195 1C44.9282 1.00014 46.3926 1.99438 46.3926 3.56836C46.3925 5.14228 44.9282 6.13658 43.5195 6.13672H29.543C32.2929 8.53945 34.2096 11.6974 34.8564 15.1143H43.5195C44.9282 15.1144 46.3926 16.1087 46.3926 17.6826C46.3926 19.2566 44.9282 20.2508 43.5195 20.251H34.8623C33.387 28.437 25.0089 34.5225 15.209 34.5225H11.4512L34.1348 52.4824L34.1465 52.4922C34.7241 52.9636 35.0737 53.6248 35.0986 54.3418C35.1235 55.061 34.8183 55.7463 34.2598 56.251L34.25 56.2598C33.1741 57.2076 31.4539 57.2513 30.3262 56.3555V56.3564L1.97852 33.9141L1.96777 33.9053L1.95801 33.8965C1.43397 33.4578 1.02663 32.7963 1.01953 32.0215L1.01855 32.0225C0.984408 30.4219 2.45733 29.4072 3.87695 29.3857H15.2256C22.0027 29.3718 27.5937 25.433 29.0049 20.251H3.87402C2.46526 20.251 1 19.2567 1 17.6826C1.00003 16.1086 2.46527 15.1143 3.87402 15.1143H28.9951C27.587 10.1304 22.0675 6.13672 15.2275 6.13672H3.87402C2.46528 6.13672 1.00006 5.14239 1 3.56836C1 1.99428 2.46526 1 3.87402 1H43.5195Z"
        fill="#232323"
        stroke="#232323"
        strokeWidth="2"
      />
    </svg>
  );
}

export default RupeeSVGnew;
